import { getLocale } from "../runtime";

const sv_usp3 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `100% hälsosamt`
};

const usp3 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_usp3(inputs)
	return "usp3";
};

export { usp3 as "usp3" };